function syncCheckboxState(checked) {
  const submitBtnNode = document.querySelector(".js-agreement-submit-btn");
  if (!submitBtnNode) {
    return;
  }

  submitBtnNode.classList.toggle("is-disabled", !checked);
}

function handleCheckboxChange(event) {
  syncCheckboxState(event.target.checked);
}

// bfcache 復帰時は change リスナーが保持されたままのため、再登録せず状態の反映のみ行う
export function syncAgreementSubmitButton() {
  const checkbox = document.querySelector(".js-agreement-checkbox");
  if (!checkbox) {
    return;
  }

  syncCheckboxState(checkbox.checked);
}

export function initAgreementCheckbox() {
  const checkbox = document.querySelector(".js-agreement-checkbox");
  if (!checkbox) {
    return;
  }

  checkbox.addEventListener("change", handleCheckboxChange);
  syncCheckboxState(checkbox.checked);
}

// readystatechange の "complete" はGTM等のasyncスクリプトの読み込み完了まで発火しないため、
// それらがブロックされてもボタンが活性化するよう DOMContentLoaded で初期化する
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAgreementCheckbox);
} else {
  initAgreementCheckbox();
}

// ブラウザバック・bfcache 復帰時はブラウザがチェック状態を復元するため、ボタン状態を取り直す
window.addEventListener("pageshow", syncAgreementSubmitButton);
